export default __webpack_public_path__ + "static/network-security-96b70f10f44b398c77cb62951a31c3b9.jpg";